import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { CamelOrderService } from '@/services/CamelOrder/CamelOrderService';

export const useCamelOrderCreateS3Image = async (
  presignedUrl: string,
  file: File
): Promise<void> => {
  const siteService = new CamelOrderService(getClient());
  try {
    const res = await siteService.createS3Image(presignedUrl, file);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
